import VacancyPreviewCard from './VacancyPreviewCard.component';

export default VacancyPreviewCard;